import { Suspense, lazy, useEffect, useState } from 'react';
import { Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// @Utility
import { setStorage, getStorage, removeStorage } from "./../../../@utility/app/storage";

// Check token
import { isToken, isUserLoggedIn } from "./../../../@core/auth/utils";

// Redux
import * as authActions from "./../../../@core/redux/actions/auth/index";
import { setShowPopupImage } from "./../../../@core/redux/actions/app/popup";

// Hooks
import useParameterUrl from "./../../../@utility/hooks/useParameterUrl";

// Sub Routes
import DepositRoute from "./pages/deposit/Layouts";
import WithdrawRoute from "./pages/withdraw/Layouts";
import ErrorRoute from "./pages/error/Routes.js";
import GameRoute from "./pages/game/Routes";

// Component
import AuthApp from "./components/Auth/index";
import ProfileApp from "./pages/profile/index";
import PromotionPopup from "./pages/deposit/component/PromotionPopup";
import PopupImages from "./../vertical/components/PopupImages";

// Routes page
import HomeApp from "./pages/home/index";
// import GamePlayApp from "./../vertical/pages/game-play/index";
import RankIframeIndex from './pages/iframe-rank';

// const HomeApp = lazy(() => import("./pages/home/index"));
const ActivityApp = lazy(() => import("./pages/activity/index"));
const PromotionApp = lazy(() => import("./pages/promotion/index"));
const HistoryApp = lazy(() => import("./pages/history/index"));
// const ShopApp = lazy(() => import("./pages/shop/index"));
// const BagApp = lazy(() => import("./pages/bag/index"));
const BankApp = lazy(() => import("./pages/bank/index"));
const PasswordApp = lazy(() => import("./pages/password/index"));
const OpenGameLotteryApp = lazy(() => import("./pages/game-lottery-play"));
const LiveChatApp = lazy(() => import("./pages/live-chat/index"));

const VerticalRoutes = ({ dataSetting, setCheckPageGameList, checkPageGameList }) => {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();
    // const dataSetting = useSelector(state => state.reduxAppMenu.menu_items);
    const parsed = useParameterUrl();
    const { login, register, affiliate, partner, refer, ref, market, clickid, platform, fbclid, remember, fbcid, fbuuid } = parsed;
    const reduxProfile = useSelector(state => state.reduxProfile);
    const reduxPromotionPopup = useSelector(state => state.reduxPromotion);
    const popupImageShow = useSelector(state => state.reduxAppPopup.popupImage);
    const [dataPopup, setDataPopup] = useState([]);
    const imagesProcessing = useSelector(state => state.reduxAppProcessing.images);
    const location = useLocation();

    const routesRouter = () => {
        return (
            <Suspense fallback={null}>
                {
                    isToken() ?
                        (dataSetting === null || dataSetting === undefined) ?
                            <Switch>
                                <Route
                                    path="/"
                                    exact
                                    render={() =>
                                        <HomeApp agent_setting_menu={dataSetting?.agent_setting_menu} pageSelect="home" checkPageGameList={checkPageGameList}></HomeApp>
                                    }>
                                </Route>
                                <Route path="*" >
                                    <Redirect to="/" />
                                </Route>
                            </Switch>
                            :
                            <Switch>
                                {/* <Route
                                    path="/shop"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <ShopApp></ShopApp> : <Redirect to="/" />
                                    }>
                                </Route> */}
                                <Route
                                    path="/activity"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <ActivityApp></ActivityApp> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route
                                    path="/password"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <PasswordApp></PasswordApp> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route
                                    path="/bank"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <BankApp></BankApp> : <Redirect to="/" />
                                    }>
                                </Route>
                                {/* <Route
                                    path="/rank"
                                    exact
                                    render={() => (dataSetting?.agent_setting_menu?.menu_statistics === 1) ?
                                        <RankApp menu_status={dataSetting?.agent_setting_menu?.menu_statistics}></RankApp> : <Redirect to="/" />
                                    }>
                                </Route> */}
                                {/* <Route
                                    path="/inbox"
                                    exact
                                    render={() => (dataSetting?.agent_setting_menu?.menu_mailbox === 1) ?
                                        <InboxApp menu_status={dataSetting?.agent_setting_menu?.menu_mailbox}></InboxApp> : <Redirect to="/" />
                                    }>
                                </Route> */}
                                {/* <Route
                                    path="/bag"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <BagApp></BagApp> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route
                                    path="/shop"
                                    exact
                                    render={() => (dataSetting?.agent_setting_menu?.menu_shop === 1) ?
                                        <ShopApp menu_status={dataSetting?.agent_setting_menu?.menu_shop}></ShopApp> : <Redirect to="/" />
                                    }>
                                </Route> */}
                                <Route
                                    path="/history"
                                    exact
                                    render={() => isUserLoggedIn() ?
                                        <HistoryApp></HistoryApp> : <Redirect to="/" />
                                    }
                                >
                                </Route>
                                <Route
                                    path="/withdraw"
                                    render={() => (dataSetting?.agent_setting_menu?.menu_withdraw === 1) ?
                                        <WithdrawRoute menu_status={dataSetting?.agent_setting_menu?.menu_withdraw}></WithdrawRoute> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route
                                    path="/deposit"
                                    render={() => (dataSetting?.agent_setting_menu?.menu_deposit === 1) ?
                                        <DepositRoute menu_status={dataSetting?.agent_setting_menu?.menu_deposit} agentData={dataSetting}></DepositRoute> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route
                                    path="/promotion"
                                    exact
                                    render={() => (dataSetting?.agent_setting_menu?.menu_promotion === 1) ?
                                        <PromotionApp menu_status={dataSetting?.agent_setting_menu?.menu_promotion}></PromotionApp> : <Redirect to="/" />
                                    }>
                                </Route>
                                <Route path="/iframe/rank">
                                    <RankIframeIndex iframe_load="true"></RankIframeIndex>
                                </Route>
                                <Route
                                    path="/live-chat"
                                    exact
                                    render={() => <LiveChatApp />}
                                >
                                </Route>
                                {/* <Route path="/game/camp/:camp/:gamecode" exact>
                                    <GamePlayApp></GamePlayApp>
                                </Route> */}
                                <Route path="/games">
                                    <GameRoute dataSetting={dataSetting} />
                                </Route>

                                <Route path="/game/:categorySelect" exact>
                                    <HomeApp
                                        agent_setting_menu={dataSetting?.agent_setting_menu}
                                        pageSelect="category"
                                        checkPageGameList={checkPageGameList}
                                    />
                                </Route>

                                {/* รวมเป็น route เดียว */}
                                {/* เพิ่ม partner เข้าไปในรูปแบบเส้นทาง (21 ส.ค. 2569)
                                    ถ้าไม่เพิ่ม /xxx/partner/711ab126 จะไม่ match แล้วตกไป
                                    หน้า 404 แทนที่จะเก็บโค้ดเชิญ */}
                                <Route path="/:random/(affiliate|partner|refer|ref|market)/:code" exact>
                                    <HomeApp
                                        agent_setting_menu={dataSetting?.agent_setting_menu}
                                        pageSelect="home"
                                        checkPageGameList={checkPageGameList}
                                    />
                                </Route>

                                <Route path="/" exact>
                                    <HomeApp
                                        agent_setting_menu={dataSetting?.agent_setting_menu}
                                        pageSelect="home"
                                        checkPageGameList={checkPageGameList}
                                    />
                                </Route>

                                <Route path="*">
                                    <Redirect to="/" />
                                </Route>
                                <Route path="*" >
                                    <Redirect to="/" />
                                </Route>
                            </Switch>
                        :
                        <Switch>
                            <Route path="/error">
                                <ErrorRoute></ErrorRoute>
                            </Route>
                            <Route
                                path="/live-chat"
                                exact
                                render={() => <LiveChatApp />}
                            >
                            </Route>
                            <Route path="*" >
                                <Redirect to="/error/token" />
                            </Route>
                        </Switch>
                }
            </Suspense>
        );
    };

    const routesRouterLottery = () => (
        <Suspense fallback={null}>
            <Switch>
                <Route
                    path="/open-game/lottery"
                    exact
                    render={() =>
                        <OpenGameLotteryApp dataSetting={dataSetting?.agent_setting_menu} />
                    }>
                </Route>
                <Route path="*" >
                    <Redirect to="/" />
                </Route>
            </Switch>
        </Suspense>
    );

    const renderContentMain = () => (
        <>
            {
                routesRouter()
            }

            <AuthApp></AuthApp>

            {
                isUserLoggedIn() && (
                    reduxProfile.show && (
                        <ProfileApp reduxProfile={reduxProfile}></ProfileApp>
                    )
                )
            }

            {
                isUserLoggedIn() && (
                    reduxPromotionPopup.show && (
                        <PromotionPopup reduxPromotionPopup={reduxPromotionPopup}></PromotionPopup>
                    )
                )
            }

            {
                imagesProcessing && (
                    popupImageShow && (
                        dataPopup.length > 0 && (
                            <PopupImages popupData={dataPopup} />
                        )
                    )
                )
            }
        </>
    );

    const renderContent = () => {
        if (location.pathname.startsWith("/open-game/lottery")) {
            return routesRouterLottery();
        }

        return renderContentMain();
    };

    useEffect(() => {
        // SHOW หน้าเข้าสู่ระบบ
        if (login === true || login === "true") {
            dispatch(authActions.openAuthenApp({ tab: "login", show: true }));
        }

        // SHOW หน้าสมัครสมาชิก
        if (register === true || register === "true") {
            dispatch(authActions.openAuthenApp({ tab: "register", show: true }));
        }

        // SHOW หน้าสมัครสมาชิก
        if (remember === true || remember === "true") {
            dispatch(authActions.openAuthenApp({ tab: "remember", show: true }));
        }

        /* ลิงก์เชิญมีสองระบบที่แยกกันเด็ดขาด กดอันไหนล่าสุดให้ลบอีกอันทิ้ง
           (21 ส.ค. 2569)

             ?affiliate=...  ระบบ affiliate เดิม
             ?partner=...    ระบบ partner (ลิงก์จากหน้า back office)

           ค่าถูกเก็บค้างในเครื่องจนกว่าจะกดสมัคร ซึ่งอาจเป็นคนละวันกัน ถ้าไม่
           ลบอีกอันทิ้ง คนที่กดลิงก์ affiliate วันจันทร์แล้วกดลิงก์ partner
           วันพุธ จะส่งไปทั้งสองค่า แล้วได้ทั้ง affiliate_customer_id และสายงาน
           partner พร้อมกัน — ชนกฎ "ลูกค้าได้รายได้ระบบเดียว" ฝั่ง backend
           ทำให้เขาโผล่ในสายงานแต่ไม่สร้างรายได้ให้ใครเลยตลอดไป */

        // เก็บข้อมูลเพื่อนที่เชิญ
        if (affiliate) {
            setStorage("affiliate", affiliate)
            removeStorage("partner")
        }

        // เก็บข้อมูลผู้เชิญเข้าระบบ partner
        if (partner) {
            setStorage("partner", partner)
            removeStorage("affiliate")
        }

        if (clickid) {
            setStorage("clickid", clickid)
        }

        if (platform) {
            setStorage("platform", platform)
        }

        if (fbclid || fbcid || fbuuid) {
            const fbParams = [fbclid, fbcid, fbuuid].find(Boolean); // หาค่าตัวแรกที่ truthy

            if (fbParams) {
                const fbclidStorage = getStorage("fbclid");
                setStorage("fbclid", fbParams);

                // const fbctimestamp = getStorage("fbctimestamp");
                if (fbclidStorage !== fbParams) {
                    const timestampUtcMilli = Date.now(); // ✅ เวลาตาม UTC
                    setStorage("fbctimestamp", timestampUtcMilli);
                }
            }
        }

        // อ้างอิง
        if (refer) {
            setStorage("refer", refer)
        } else if (ref) {
            setStorage("refer", ref)
        }

        // การตลาด
        if (market) {
            setStorage("market", market)
        }
    }, [login, register, affiliate, partner, refer, ref, dispatch]);

    useEffect(() => {
        const isNumber = (n) => {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
        };

        if (dataSetting.agent_image !== null) {
            const dataAgentImages = dataSetting.agent_image;
            const pathName = window.location.pathname;
            const dataImagesPopup = dataAgentImages.filter((item) => {
                return item.image_position === "popup";
            });

            if (dataImagesPopup.length > 0) {
                const dataArr = dataImagesPopup.filter((item) => {
                    let timeStorage = getStorage(item.id);
                    let statusPopup = false;
                    let timeNext = (new Date().getTime() / 1000) + item.image_frequency;
                    if (timeStorage === undefined || timeStorage === null) {
                        setStorage(item.id, timeNext);
                        statusPopup = true;
                    }
                    else {
                        if (isNumber(timeStorage)) {
                            let timeNow = (new Date().getTime() / 1000);
                            if (timeNow > Number(timeStorage)) {
                                setStorage(item.id, (Number(timeStorage) + item.image_frequenc));
                                statusPopup = true;
                            }
                            else {
                                statusPopup = false;
                            }
                        }
                        else {
                            setStorage(item.id, timeNext);
                            statusPopup = true;
                        }
                    }

                    if (statusPopup) {
                        if (pathName === "/") {
                            return item.image_path === "" || item.image_path === "/";
                        }
                        else {
                            if (item.image_path === "*") {
                                return item.image_path;
                            }
                            else {
                                return item.image_path === pathName;
                            }
                        }
                    }
                });

                if (dataArr.length > 0) {
                    setDataPopup(dataArr);
                    dispatch(setShowPopupImage(true));
                }
            }
        }
        else {
            setDataPopup([]);
        }
    }, [dataSetting.agent_image, window.location.href]);

    useEffect(() => {
        if (location.pathname.startsWith("/game/")) {
            if (setCheckPageGameList) {
                setCheckPageGameList(true);
            }
        }
        else {
            setCheckPageGameList(false);
        }
    }, [location.pathname]);

    return renderContent();
};

export default VerticalRoutes;